export const LogoMark = ({ className = "h-12 w-12" }) => (
  <img src="/logo-mark.png" alt="Logo HidroPro" className={`${className} shrink-0 object-contain`} />
);

export const Logo = ({ dark = false }) => (
  <span className="flex items-center gap-3">
    <LogoMark className="h-14 w-14 shrink-0" />
    <span className="flex flex-col leading-none">
      <span className={`font-display text-lg font-extrabold tracking-tight ${dark ? "text-white" : "text-[#1A1A1A]"}`}>
        HIDRO<span className="text-[#0A5C8C]">PRO</span>
      </span>
      <span className={`mt-1 font-mono text-[9px] uppercase tracking-[0.28em] ${dark ? "text-white/60" : "text-[#4A5568]"}`}>
        Serviços Técnicos
      </span>
    </span>
  </span>
);
